/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { EventBusModule } from '@common/event-bus-module';

import { CREATE_POLICY } from '@pages/BuyInsurancePage/apis/graphql';

import { Graphql } from '@common/graphql';
import { apiConfig } from '@pages/BuyInsurancePage/config/api.config';
import { AppNavigatorService } from '@/AppNavigator/services';
import { vappContainer } from '@/application';

export interface ICreatePolicyProps {
  beneficiaryFirstName?: string;
  beneficiaryLastName?: string;
  beneficiaryStreetAddress?: string;
  beneficiaryCity?: String;
  beneficiaryCountry?: string;
  beneficiaryTelephone?: string;
  beneficiaryEmail?: string;
  policyOption?: any;
  policyCoverage: string;
  policyPremium?: string;
  intendedPurpose?: any;
  termsData?: any;
  country?: string;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface ICreatePolicyMethods extends IPluginMethodMap {
  getCreatePolicyProps(args: ICreatePolicyProps): Promise<any>;
}

export class CreatePolicyPlugin implements IAgentPlugin {
  readonly methods: ICreatePolicyMethods;

  constructor() {
    this.methods = {
      getCreatePolicyProps: this.getProps.bind(this),
    };
  }

  async getProps(args: ICreatePolicyProps) {
    console.log(`args in kyc submit`, args);
    return await this.submitKyc(args);
  }

  private async submitKyc(args: any) {
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .mutation(CREATE_POLICY, {
          input: {
            benificiaryDetail: {
              firstName: args?.beneficiaryFirstName,
              lastName: args?.beneficiaryLastName,
              email: args?.beneficiaryEmail,
              mobileNo: args?.beneficiaryTelephone,
              address: {
                addressLine1: args?.beneficiaryStreetAddress,
                city: args?.beneficiaryCity,
                country: args?.beneficiaryCountry,
              },
            },
            countryName: args?.country,
            coverage: parseFloat(args?.policyCoverage),
            premium: args?.policyOption?.premium?.raw,
            productDefination: args?.policyOption?.id,
          },
        })
        .toPromise();

      if (res?.data) {
        return res?.data;
      }
    } catch (err: any) {
      throw err;
    }
  }
}
